.emailRow {
  display: flex;
  /* --auth-email-row-wrap / --auth-email-input-flex: a product whose button is too wide for one
   * row at 390 lets it wrap under the field (Quies). Defaults are the original values — wrapping
   * by default moved ovid's button under its field and narrowed narcis's row at 390 (measured
   * 2026-09-28). */
  flex-wrap: var(--auth-email-row-wrap, nowrap);
  gap: 8px;
  width: 100%;
  max-width: 360px;
}

.emailInput {
  flex: var(--auth-email-input-flex, 1);
  min-width: 0;
  padding: 10px 14px;
  border-radius: var(--radius-sm, 6px);
  /* --auth-input-border/--auth-input-bg (2026-07-14): independent hooks from --border/--surface
   * so a product can give the input a distinct hairline/fill from the divider and the card
   * without repointing those two shared vars everywhere else they're read. Defaults fall back to
   * the original narcis vars — no behavior change unless a caller sets the new ones. */
  border: 1px solid var(--auth-input-border, var(--border));
  background: var(--auth-input-bg, var(--surface));
  color: var(--text);
  font-size: 0.95rem;
  font-family: var(--font-body);

  &::placeholder {
    color: var(--text-dim);
  }

  &:focus {
    outline: none;
    border-color: var(--yolk);
  }

  &:focus-visible {
    outline: 2px solid var(--yolk);
    outline-offset: 2px;
  }
}

/* Yolk-filled CTA — spec §7a. On ovid this is the page's one solid CTA (ember fill) when the gate
 * occupies the primary-CTA slot — --yolk/--yolk-hover/--yolk-pressed/--ink are remapped per-product
 * (ovid: authGateVars mixin). Hover/active swap to dedicated vars (default = --yolk itself, so
 * narcis keeps its current opacity-only dim with no color change) instead of always dimming, so a
 * product wanting a pure background swap (ovid's ctaButtonActive convention) can opt in via
 * --auth-submit-hover-opacity: 1.
 *
 * Fill/text/border read --auth-submit-* first, falling back to --yolk/--ink — narcis and every
 * existing SignupGate mount set none of these, so they keep the solid fill byte-identical. A house
 * whose board draws this as the quiet outlined button instead of the one solid CTA (quies login,
 * `thinking/design/quies/pages/login/`: `btn--quiet` with a hairline border) sets the --auth-submit-*
 * trio instead of forking this component. */
.sendButton {
  background: var(--auth-submit-bg, var(--yolk)) !important;
  background-image: none !important;
  color: var(--auth-submit-text, var(--ink)) !important;
  border-color: var(--auth-submit-border, var(--yolk)) !important;
  border-radius: var(--radius-sm, 6px) !important;
  font-family: var(--font-body) !important;
  font-weight: var(--auth-control-weight, 500) !important;
  font-size: var(--auth-control-size, 0.9375rem) !important;
  letter-spacing: var(--auth-control-tracking, 0.025em) !important;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: var(--auth-submit-hover-bg, var(--yolk-hover, var(--yolk))) !important;
    border-color: var(--auth-submit-hover-border, var(--yolk-hover, var(--yolk))) !important;
    color: var(--auth-submit-hover-text, var(--auth-submit-text, var(--ink))) !important;
    opacity: var(--auth-submit-hover-opacity, 0.9);
    transform: none;
    box-shadow: none;
    filter: none;
  }

  &:active:not(:disabled) {
    background: var(--auth-submit-active-bg, var(--yolk-pressed, var(--yolk))) !important;
    border-color: var(--auth-submit-active-border, var(--yolk-pressed, var(--yolk))) !important;
  }

  &:disabled {
    opacity: 0.6;
  }
}

.sentMessage {
  color: var(--success);
  font-size: 0.95rem;
  padding: 8px 0;
}

.errorMessage {
  color: var(--error);
  font-size: 0.85rem;
  margin-top: 6px;
}

/* The view a link has been sent to (copy.waiting): the product's own heading and line, a quiet
 * outlined "send again", and whatever way out the caller puts beneath. */
.waiting {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.waitingTitle {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text);
}

.waitingBody {
  margin: 0;
  max-width: 360px;
  font-size: 0.95rem;
  line-height: 1.5;
  color: var(--text-muted);
  overflow-wrap: anywhere;
}

.resend {
  width: 100%;
}

.resendButton {
  width: 100%;
  background: transparent !important;
  background-image: none !important;
  color: var(--text) !important;
  border: 1px solid var(--auth-input-border, var(--border)) !important;
  border-radius: var(--radius-sm, 6px) !important;
  font-family: var(--font-body) !important;
  font-weight: var(--auth-control-weight, 500) !important;
  font-size: var(--auth-control-size, 0.9375rem) !important;
  letter-spacing: var(--auth-control-tracking, 0.025em) !important;

  &:disabled {
    opacity: 0.6;
  }
}
